import { resetIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Refresh = createIcon({
  displayName: 'Refresh',
  paths: [
    'M811.11 286.149c0-23.595-19.115-42.667-42.667-42.667s-42.667 19.072-42.667 42.667v18.475c-13.739-14.165-28.715-27.563-45.824-39.381-98.901-68.437-233.643-69.333-333.184-1.877-176.043 119.296-177.877 372.18-5.547 494.292 94.123 66.688 222.379 71.509 321.579 12.672 41.557-24.619 73.728-56.32 97.493-92.032 14.293-21.461 4.608-50.901-18.901-61.611-19.413-8.832-41.813-1.707-53.632 16.085-17.877 26.923-42.709 50.56-76.715 67.797-74.667 37.973-167.765 30.805-232.832-21.931-112.939-91.52-105.472-268.287 22.485-348.5 57.771-36.181 131.84-40.832 194.432-13.909 31.872 13.653 56.491 33.024 76.075 55.253h-30.763c-23.552 0-42.667 19.072-42.667 42.667s19.115 42.666 42.667 42.666h128c11.776 0 22.443-4.779 30.165-12.501s12.501-18.388 12.501-30.164v-128z'
  ],
  canvasPaths: canvasIconPaths(resetIcon)
})
